// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

/**
 * Schema for inventory update response.
 */
const updateInventoryResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
  }),
  metadata: responseMetadataSchema,
});

/**
 * Adds or removes stock of an item at a specific location.
 *
 * @param params Object containing locationKey, itemId, direction, a positive quantity, and the reason
 * @returns Promise resolving to success status
 */
export async function updateInventory(params: {
  locationKey: string;
  itemId: string;
  direction: 'INCREASE' | 'DECREASE';
  quantity: number;
  reason: string;
  note?: string;
}) {
  const { locationKey, ...rest } = params;
  const url = `/v1/location-inventory/${locationKey}`;
  const response = await api.put(url, rest);
  return parseResponse(updateInventoryResponseSchema, response.data, {
    schemaName: 'UpdateInventory',
    endpoint: url,
  });
}
